<div class="flex flex-1">
  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="3"
    class="flex-1"
  >
    <dxi-item
      dataField="size"
      editorType="dxSelectBox"
      [label]="{
        text: 'Dimensione' | transloco,
        location: 'left',
        visible: false
      }"
      [editorOptions]="{
        placeholder: 'Dimensione' | transloco,
        valueExpr: 'value',
        displayExpr: 'display',
        dataSource: [
          { value: '1', display: '1' | transloco },
          { value: '2', display: '2' | transloco },
          { value: '3', display: '3' | transloco },
          { value: '4', display: '4' | transloco },
          { value: '5', display: '5' | transloco }
        ]
      }"
    ></dxi-item>
    <dxi-item
      dataField="separator"
      editorType="dxSwitch"
      [label]="{
        text: 'Separatore' | transloco,
        location: 'left',
        showColon: false
      }"
    ></dxi-item>
    <dxi-item
      dataField="dashed"
      editorType="dxSwitch"
      [label]="{
        text: 'Tratteggiato' | transloco,
        location: 'left',
        showColon: false
      }"
    ></dxi-item>
  </dx-form>
</div>
